import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
  list: []
};
// Create compaignListSlice with name and initial state
const compaignListSlice = createSlice({
  name: 'compaignList',
  initialState,
  reducers: {
    // Create action with name and payload
    setCompaignList: (state, action) => {
      state.list = action.payload;
    }
  }
});

// Export action to use in component
export const { setCompaignList } = compaignListSlice.actions;

// Export the reducer for the slice
export default compaignListSlice.reducer;
